export default class perfilinvController{

    constructor($scope,$uiGridConstants,$http,perfilSrv,ngNotify,$cookies,UserInfoConstant, $stateParams){
        this.$scope = $scope;
        this.$uiGridConstants = $uiGridConstants;
        this.$http = $http;
        this.perfilSrv = perfilSrv;
        this.ngNotify = ngNotify;
        this.$cookies = $cookies;
        this.$stateParams = $stateParams;
        this.$scope.UserInfoConstant = UserInfoConstant;
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.userinfo.role_id = this.$cookies.get('hasRoleId');
                this.main();
            }
        });
    }

    main() {
        /**
        * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
        **/
        if (this.$stateParams.teacherId != '') {
            this.userinfo.teacherId = this.$stateParams.teacherId;
            this.PerfildeInvestigacionChart(this.userinfo.teacherId);
        } else {
            this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
                if (!response.status) {
                    this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
                } else {
                    this.role = response.data[0];
                    if (this.role.types == 'TEACHER') {
                        this.getInfo();
                    }
                }
            }, (err) => {
                this.ngNotify.set('Imposible conectar con el servicio', 'error');
            });
        }
    }

    getInfo() {
        this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                this.userinfo.teacherId = response.data[0].idTeacher;
                this.PerfildeInvestigacionChart(this.userinfo.teacherId);
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    PerfildeInvestigacionChart(teacherId) {
        this.perfilSrv.perfildocente.PerfildeInvestigacionChart({teacherId:teacherId}).$promise.then((response) => {
            let chart = {
                chart: {type: 'column'},
                title: {
                        style: {
                            fontWeight: 'bold'
                        },
                        align: 'center',
                        text: 'Producción Científica'},//'Última actualización el ' + response.data.lastUpdate},
                xAxis: {categories: response.data.category, labels: {x: -10 } },
                yAxis: {
                    tickInterval: 1,
                    minRange: 1,
                    allowDecimals: false,
                    title: {text: ""} },
                series: response.data.series,
                plotOptions: {column: {stacking: 'normal'}},
                size: {height: "300", },
                tooltip: {
                    formatter: function () {
                        return '<b>' + this.x + '</b><br/>' +
                        this.series.name + ': ' + this.y + '<br/>' +
                        'Total: ' + this.point.stackTotal;
                    }
                },
            }

            Highcharts.chart('containt', chart);
        }, (data) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }
}

perfilinvController.$inject = ['$scope','uiGridConstants','$http','perfilSrv','ngNotify','$cookies','UserInfoConstant', '$stateParams'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_investigation/perfilinvchartController.js